<template>
  <el-drawer v-if="entities && condition" :visible.sync="show" append-to-body :modal="false" direction="ltr" title="切换患者" :show-close="false" :size="350">
    <template slot="title">
      <el-row>
        就诊记录
        <el-row type="flex" justify="space-around" align="middle" class="top-pad">
          <el-tag size="mini" type="info" hit class="center">{{ condition.pageIndexOnView }}</el-tag>
          <el-pagination
            v-if="entities.items && entities.items.length"
            layout="total, sizes, prev, next"
            :page-sizes="[10, 20, 50, 100]"
            @size-change="$emit('paging')"
            @current-change="$emit('paging')"
            :current-page.sync="condition.pageIndexOnView"
            :page-size.sync="condition.pageSize"
            :total="entities.total"
            small
          />
          <el-button type="primary" @click="$emit('refreshing')" icon="el-icon-refresh" size="mini" title="数据同步" circle plain> </el-button>
        </el-row>
      </el-row>
    </template>

    <el-table :data="entities.items" :show-header="false" size="mini" @row-click="select" :row-style="rowStyle">
      <el-table-column prop="patientName">
        <template slot-scope="{ row }">
          <span class="sub-title"><i class="el-icon-user"></i> {{ row.patientName }}</span>
        </template>
      </el-table-column>
      <el-table-column width="100">
        <template #default="{ row }">
          <el-row>{{ row.date | fmtDate }}</el-row>
          <el-row>
            <span> {{ row.patientGender | dictText("Gender") }}</span> <span>{{ row.patientAge }}</span>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column width="130">
        <template slot-scope="{ row }">
          <el-row>{{ row.opNo || row.ipNo }} </el-row>
          <el-row>{{ row.deptCode | dictText("Dept") }} {{ row.doctorName }}</el-row>
        </template>
      </el-table-column>
    </el-table>
  </el-drawer>
</template>
<script>
  export default {
    props: {
      visible: Boolean,
      entities: Object,
      condition: Object,
      record: Object, // 病历
    },
    data() {
      return {
        show: false,
      };
    },
    watch: {
      visible(val) {
        this.show = val;
      },
      show(val) {
        this.$emit("update:visible", val);
      },
    },
    methods: {
      select(row) {
        if (row?.mrMain && row?.mrMain.id == this.record?.id) {
          return;
        }
        this.$emit("ok", row);
      },
      rowStyle({ row }) {
        if (row.mrMain && row.mrMain.id == this.record?.id) {
          return {
            color: "#C0C4CC",
            cursor: "not-allowed ",
          };
        }
        return {
          color: "#409EFF",
          cursor: "pointer",
        };
      },
    },
  };
</script>
